import * as Types from '../types';

import { gql } from 'apollo-angular';
export type SharedProductFieldsFragment = { __typename?: 'Product', has_shared?: boolean | null, id: string, name?: string | null, shares_count?: number | null, slug?: string | null, brand?: { __typename?: 'Brand', id: string, name?: string | null, username?: string | null, media?: Array<{ __typename?: 'Media', id: string, type?: string | null, url?: string | null, sizes?: { __typename?: 'MediaSizes', id?: string | null, thumbnail?: string | null } | null }> | null } | null, media?: Array<{ __typename?: 'Media', id: string, type?: string | null, url?: string | null, sizes?: { __typename?: 'MediaSizes', id?: string | null, thumbnail?: string | null, small?: string | null, medium?: string | null, large?: string | null, xLarge?: string | null } | null }> | null };

export const SharedProductFieldsFragmentDoc = gql`
    fragment SharedProductFields on Product {
  brand {
    id
    media {
      id
      type
      url
      sizes {
        id
        thumbnail
      }
    }
    name
    username
  }
  has_shared
  id
  media {
    id
    type
    url
    sizes {
      id
      thumbnail
      small
      medium
      large
      xLarge
    }
  }
  name
  shares_count
  slug
}
    `;